/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiCustomListSchemaField } from './InternalApiCustomListSchemaField';
import {
    InternalApiCustomListSchemaFieldFromJSON,
    InternalApiCustomListSchemaFieldFromJSONTyped,
    InternalApiCustomListSchemaFieldToJSON,
    InternalApiCustomListSchemaFieldToJSONTyped,
} from './InternalApiCustomListSchemaField';

/**
 * a custom list schema
 * @export
 * @interface InternalApiCustomListSchema
 */
export interface InternalApiCustomListSchema {
    /**
     * 
     * @type {string}
     * @memberof InternalApiCustomListSchema
     */
    customListId: string;
    /**
     * 
     * @type {Array<InternalApiCustomListSchemaField>}
     * @memberof InternalApiCustomListSchema
     */
    schemaFields: Array<InternalApiCustomListSchemaField>;
}

/**
 * Check if a given object implements the InternalApiCustomListSchema interface.
 */
export function instanceOfInternalApiCustomListSchema(value: object): value is InternalApiCustomListSchema {
    if (!('customListId' in value) || value['customListId'] === undefined) return false;
    if (!('schemaFields' in value) || value['schemaFields'] === undefined) return false;
    return true;
}

export function InternalApiCustomListSchemaFromJSON(json: any): InternalApiCustomListSchema {
    return InternalApiCustomListSchemaFromJSONTyped(json, false);
}

export function InternalApiCustomListSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiCustomListSchema {
    if (json == null) {
        return json;
    }
    return {
        
        'customListId': json['customListId'],
        'schemaFields': ((json['schemaFields'] as Array<any>).map(InternalApiCustomListSchemaFieldFromJSON)),
    };
}

export function InternalApiCustomListSchemaToJSON(json: any): InternalApiCustomListSchema {
    return InternalApiCustomListSchemaToJSONTyped(json, false);
}

export function InternalApiCustomListSchemaToJSONTyped(value?: InternalApiCustomListSchema | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'customListId': value['customListId'],
        'schemaFields': ((value['schemaFields'] as Array<any>).map(InternalApiCustomListSchemaFieldToJSON)),
    };
}

